exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#app * .cov-date-body {\n  font-family: \"Raleway\";\n}", ""]);

// exports
